"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceBreak = void 0;
const common_1 = require("../../common");
const product_model_1 = require("./product.model");
class ProductPriceBreak extends common_1.MongoDocument {
}
exports.ProductPriceBreak = ProductPriceBreak;
//# sourceMappingURL=product-price-break.model.js.map